import { styled } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const Wrapper = styled('div')(({ theme, wrapperStyles }) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
  minHeight: '400px',
  border: theme.border.default,
  borderRadius: theme.border.radius,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  ...wrapperStyles,
}));
